export const Job = Object.freeze({
  REDBEE_MSS_DELIVERY: {
    label: "RedBee MSS Delivery",
    key: "redBeeMssDelivery",
  },
  ZEUS_CONTENT_DECRYPTION: {
    label: "Zeus Content Decryption Job",
    key: "zeusContentDecryptionJob",
  },
  HBBTV_MEDIAPACKAGE: {
    label: "HbbTV MediaPackage Job",
    key: "hbbTvMediaPackageJob",
  },
  HBBTV_CAPELLA_PACKAGING: {
    label: "HbbTv Capella Packing Job",
    key: "hbbTvCapellaPackingJob",
  },
  HBBTV_CREATE_CASSIE_CONTENT_PACKAGE: {
    label: "HbbTV Create Cassie Content Package",
    key: "hbbTvCreateCassieContentPackage",
  },
  APOLLO_THUMBNAILS_GENERATION: {
    label: "Apollo Thumbnails Generation Job",
    key: "apolloThumbnailsGenerationJob",
  },
  APOLLO_CREATE_CASSIE_THUMBNAIL_PACKAGE: {
    label: "Apollo Create Cassie Thumbnail Package",
    key: "apolloCreateCassieThumbnailPackage",
  },
  AD_TRACK_DECRYPTION: {
    label: "AD track decryption",
    key: "adTrackDecryption",
  },
  HYDRA_ISO_DASH_MEDIAPACKAGE: {
    label: "Hydra ISO-DASH MediaPackage Job",
    key: "hydraIsoDashMediaPackageJob",
  },
  HYDRA_ISO_DASH_MANIFEST_REWRITE: {
    label: "Hydra ISO-DASH Manifest Rewrite",
    key: "hydraIsoDashManifestRewrite",
  },
  HYDRA_ISO_DASH_CREATE_CASSIE_CONTENT_PACKAGE: {
    label: "Hydra ISO-DASH Create Cassie Content Package",
    key: "hydraIsoDashCreateCassieContentPackage",
  },
  HYDRA_HLS_MEDIAPACKAGE: {
    label: "Hydra HLS MediaPackage Job",
    key: "hydraHlsMediaPackageJob",
  },
  HYDRA_HLS_CREATE_CASSIE_CONTENT_PACKAGE: {
    label: "Hydra HLS Create Cassie Content Package",
    key: "hydraHlsCreateCassieContentPackage",
  },
});
